// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OuKOH","content":"styles_content__15mGC","tableWrap":"styles_tableWrap__3jX8w"};